import { Node, mergeAttributes } from "@tiptap/core"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { TocNodeComponent } from "@/tiptap/nodes/toc-node/toc-node"

/**
 * A Tiptap node extension that creates a table of contents node.
 * @see registry/tiptap-node/toc-node/toc-node-component
 */
export const TocNode = Node.create({
  name: "tocNode",

  group: "block customNode",

  draggable: true,

  selectable: true,

  atom: true,

  addOptions() {
    return {
      topOffset: 0,
      maxShowCount: 20,
      showTitle: true,
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      topOffset: {
        default: null,
        parseHTML: (element) => {
          const val = element.getAttribute("data-top-offset")
          const num = val != null ? Number(val) : null
          return Number.isFinite(num) ? num : null;
        },
        renderHTML: (attrs) => {
          if (attrs.topOffset == null) return {}
          return { "data-top-offset": attrs.topOffset }
        },
      },
      maxShowCount: {
        default: null,
        parseHTML: (element) => {
          const val = element.getAttribute("data-max-show-count")
          const num = val != null ? Number(val) : null
          return Number.isFinite(num) ? num : null;
        },
        renderHTML: (attrs) => {
          if (attrs.maxShowCount == null) return {}
          return { "data-max-show-count": attrs.maxShowCount }
        },
      },
      showTitle: {
        default: true,

        parseHTML: (element) => {
          const val = element.getAttribute("data-show-title")
          if (val === "false") return false
          if (val === "true") return true
          return null
        },

        renderHTML: (attrs) => {
          if (attrs.showTitle == null) return {}
          return { "data-show-title": String(attrs.showTitle) };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="toc-node"]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": "toc-node",
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TocNodeComponent, {
      stopEvent: ({ event }) => {
        if (!(event instanceof MouseEvent)) return false

        const el = event.target
        if (!el) return false

        return Boolean(el.closest(".tiptap-table-of-contents-item"));
      },
    });
  },

  addCommands() {
    return {
      insertTocNode:
        (attrs) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs,
          });
        },
    };
  },
})

export default TocNode
